import { useEffect, useState } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { useMutation } from "@tanstack/react-query";

import { SubmitButton } from "ui-components/Form";
import { Layout } from "ui-components/Layout";
import { Success, Error_ } from "ui-components/Alert";
import LocationGroupInfo from "./components/LocationGroupInfo";
import { createLocationGroup } from "services/data.internal.service";
import { formRender, initialValues, locationGroupValidations } from "./location-group-schema";

function AddLocationGroup() {
  const [alert, setAlert] = useState(null);
  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);

  const createLocationGroupMutation = useMutation(createLocationGroup, {
    onSuccess: (data) => setAlert(<Success data={data} onChange={setAlert} />),
    onError,
  });
  const form = useForm({
    defaultValues: initialValues,
    values: {...initialValues, volumeUOM: "M3", weightUOM: "KG"} ,
    resolver: yupResolver(locationGroupValidations),
  });

  const {
    getValues,
    control,
    handleSubmit,
    formState: { errors, isSubmitting },
    setValue,
    reset,
  } = form;

  const infoProps = {
    getValues,
    control,
    errors,
    setValue,
    formRender,
  };

  const onSubmit = (data) => {
    let invalidCount = 0;
    console.log(data);
    if (!data.locGrpType) {
      setAlert(<Error_ content="Location Group Type is compulsory" onChange={setAlert} />);
      return;
    }
    if (data.grossDepth <= 0 || data.grossHeight <= 0 || data.grossWidth <= 0){
      if ((data.grossDepth > 0 !== data.grossHeight > 0) || (data.grossHeight > 0 !== data.grossWidth > 0)){
        setAlert(<Error_ content="Invalid dimension, Gross Weight, Gross Height and Gross Width are required" onChange={setAlert} />);
        return;
      } else invalidCount++;
    }
    if (data.volumeCBM <= 0 || !Boolean(data.volumeUOM)){
      if (data.volumeCBM > 0 && !Boolean(data.volumeUOM)){
        setAlert(<Error_ content="Volume CBM must have Volume UOM" onChange={setAlert} />);
        return;
      } else invalidCount++;
    }
    if (data.maxWeight <= 0 || !Boolean(data.weightUOM)){
      if (data.maxWeight > 0 && !Boolean(data.weightUOM)){
        setAlert(<Error_ content="Max Weight must have Weight UOM" onChange={setAlert} />);
        return;
      } else invalidCount++;
    }
    if (invalidCount >= 3){
      setAlert(<Error_ content="Location Dimension Group must have at least one dimension, volume or weight" onChange={setAlert} />);
      return;
    }
    createLocationGroupMutation.mutate(data, {
      onSuccess: () => {
        reset();
        setAlert(<Success content="Added" onChange={setAlert} />);
      },
    });
  };
  const createStatus = createLocationGroupMutation.status === "loading"
  return (
    <Layout>
      {alert}
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <LocationGroupInfo {...infoProps} />
        <SubmitButton label="submit" disabled={createStatus} url="/setup/location-group" />
      </form>
    </Layout>
  );
}

export default AddLocationGroup;
